import React from 'react'
import ComponentpediaLink, {ComponentpediaLinkTypes} from '../componentpedia';
import RegistryUrl from '../registry.url';

const ComponentExclusionsCard = (props) => {
    const { index, url, name, version, scope, transitive, language, isLatest } = props;
    return (
        <div className="col-lg-8 exclusions-list" data-language={language} data-lib={name + version}>
            <div className="report-box" id={`advice-${name + index}`} key={name + index}>
                <div className="report-box-header report-dependency gray">
                    <div className="report-box-title">
                        {isLatest ?
                            <div className="text-link pr-0" value="" title="See in dependency tree" 
                                tabIndex={0}
                                onClick={() => { props.findDependencyInTree(language, name + " " + version) }} 
                                onKeyUp={(e) => { props.findDependencyInTree(language, name + " " + version, {key: e.key}) }} >{name + ":" + version}</div> :
                            <div className="text-white pr-0" value=""  >{name + ":" + version}</div>
                        }
                        <ComponentpediaLink class={"advice-link mr-1"} language={language} name={name} version={version} type={ComponentpediaLinkTypes.SM} />
						<RegistryUrl language={language} name={name} version={version} class={"advice-link mr-1"} />
                        {scope ? <small className="badge badge-custom">{scope}</small> : ""}
                        {transitive ? <small className="badge badge-custom badge-transitive">transitive</small> : ""}
                    </div>
                    <span className="hidden-xs"> {language} </span>
                </div>
                {props.children}

            </div>
        </div>
    )
}

export default ComponentExclusionsCard